import React from "react";
import { connect } from "react-redux";

// CSS
import "../../css/footer/contact-info.css";

// Utils
import { nl2br } from "../../utils/nl2br";

const translationKey = "app";

class ContactInfo extends React.PureComponent {
	render() {
		const { translationsLoading, translations } = this.props;

		return (
			<div className="footer-contact-info">
				{!translationsLoading &&
					nl2br(translations.sections[translationKey].footer_address)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translationsLoading:
			state.translations.isLoading[translationKey] === undefined
				? 1
				: state.translations.isLoading[translationKey],
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(ContactInfo);



// WEBPACK FOOTER //
// ./src/components/footer/ContactInfo.js